import { render, staticRenderFns } from "./wechatuser.vue?vue&type=template&id=c5a11374&"
import script from "./wechatuser.vue?vue&type=script&lang=js&"
export * from "./wechatuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports